import React from 'react';
import {X3Level} from '../../../domain';
import {TooltipBreadcrumb} from '../../../lib/components';
import {routes} from '../../../pages/Routes';

export class X3LevelBreadcrumbs extends React.Component<{ level: X3Level }> {
  render() {
    const {level} = this.props;
    return (
      <div className="row" key="breadcrumbs">
        <div className="col">
          <div className="breadcrumb">
            <TooltipBreadcrumb tooltip="Languages"
                               label="Languages"
                               route={routes.X1LanguageList}/>

            <TooltipBreadcrumb tooltip="Language"
                               label={level!.AgeCategory!.Language!.Name}
                               route={routes.x1language(level!.AgeCategory!.LanguageId)}/>

            <TooltipBreadcrumb tooltip="Age Category"
                               label={level!.AgeCategory!.Name}
                               route={routes.x2ageCategory(level!.AgeCategoryId)}/>

            <TooltipBreadcrumb tooltip="Level"
                               label={level!.Name}
                               active/>
          </div>
        </div>
      </div>
    );
  }
}
